import { useEffect, useState } from "react";

const useAuth = (): boolean | undefined => {
  const [loggedIn, setLoggedIn] = useState<boolean | undefined>(); // <-- undefined

  useEffect(() => {
    const token = sessionStorage.getItem("accessToken");
    if (token !== null && token !== "") {
      setLoggedIn(true);
    }
  }, []);

  return loggedIn;
};

export default useAuth;
